module.exports = __webpack_public_path__ + "files/83f43343ec878d466e1c7d5a2c526dd4.png";